import makeStyles from '@material-ui/core/styles/makeStyles';

const styles = makeStyles((theme) => ({
  observationText: {
    fontFamily: 'inherit',
    fontSize: '0.75rem',
    lineHeight: '150%',
    color: theme.palette.grey[500],
    '& > a': { fontWeight: 700, color: theme.palette.grey[500] },
  },
  warningAlert: {
    padding: '4px 8px',
    marginTop: '12px',
  },
  warningText: {
    backgroundColor: 'red',
    color: 'white',
    fontSize: '0.875rem',
    borderRadius: '4px',
    padding: '4px 8px',
    marginTop: '8px',
  },
}));

export default styles;
